export default "__VITE_ASSET__BWzJWilF__"